// src/components/Services.jsx

import React from 'react';

const RiskandMitigation = () => {
  return (
    <div>
      <h2 className="text-4xl font-bold text-black mb-5">
      Risk Analysis and<span className="text-[#680099] ml-2 font-bold">Mitigation Strategies</span>
</h2>
      

      {/* Container for the two boxes */}
      <div style={boxesContainerStyle}>
        {/* Left box */}
        <div style={leftBoxStyle}>
          <div style={boxHeadingStyle}>Risk</div>
          <p style={boxContentStyle}> Regulatory Delays</p>
          <p style={leftboxContentStyle}> Competitive Pressure</p>
          <p style={leftboxContentStyle}> Economic Slowdown</p>
          <p style={leftboxContentStyle}> Operational Risks</p>

        </div>

        <div style={leftBoxStyle1}>
          <div style={boxHeadingStyle}>Likelihood</div>
          <p style={boxContentStyle}> Medium</p>
          <p style={leftboxContentStyle}> Medium</p>
          <p style={leftboxContentStyle}> Medium</p>
          <p style={leftboxContentStyle}> Medium</p>
        </div>

        <div style={leftBoxStyle1}>
          <div style={boxHeadingStyle}>Impact</div>
          <p style={boxContentStyle}> High</p>
          <p style={leftboxContentStyle}> Medium</p>
          <p style={leftboxContentStyle}> Medium</p>
          <p style={leftboxContentStyle}> High</p>
        </div>

    

        <div style={rightBoxStyle}>
          <div style={boxHeadingStyle}>Mitigation Strategy</div>
          <p style={boxContentStyle}>Timely Compliance and Alternative Revenue Streams. </p>
          <p style={rightboxContentStyle}>Forex Integration and Unique Customization Strengthen Differentiation.</p>
          <p style={rightboxContentStyle}>Market Diversification and Flexible Pricing.</p>
          <p style={rightboxContentStyle}>Regular Maintenance, Data Backup, And Security Protocols</p>

        </div>
      </div>




      
    </div>
  );
};



const boxesContainerStyle = {
  display: 'flex',  // Align items side by side
  gap: '20px',  // Space between the boxes
  marginTop: '19px',  // Optional: space between heading and boxes

};

const leftBoxStyle = {
  flex: 1,  // Takes up available space, but narrower due to specific width
  maxWidth: '20%',  // Adjust width to make it narrower
  backgroundColor: '#fbf4ff',  // Background color for the box
  borderRadius: '30px',
  padding: '0px',

};

const leftBoxStyle1 = {
  flex: 1,  // Takes up available space, but narrower due to specific width
  maxWidth: '14%',  // Adjust width to make it narrower
  backgroundColor: '#fbf4ff',  // Background color for the box
  borderRadius: '30px',
  padding: '0px',
};


const rightBoxStyle = {
  flex: 1,  // Takes up available space
  backgroundColor: '#fbf4ff',  // Background color for the box
  borderRadius: '30px',
  padding: '0px',
  maxWidth: '60%',  // Adjust width to make it narrower

};

const boxHeadingStyle = {
  backgroundColor: '#321e5d',  // Background color for the heading
  color: 'white',
  padding: '10px',
  borderRadius: '30px 30px 0px 0px',   
  fontSize: '18px',
  fontWeight: 'bold',  
  textAlign: 'center',

  
};

const boxContentStyle = {
  
  textAlign: 'center',
  marginTop: '20px',
  fontSize: '18px'
};


const leftboxContentStyle = {
  
  textAlign: 'center',
  marginTop: '20px',
  fontSize: '18px',
  marginTop: '55px'
};

const rightboxContentStyle = {
  
  textAlign: 'center',
  marginTop: '20px',
  fontSize: '18px',
  marginTop: '45px'
};


export default RiskandMitigation;
